<template>
  <v-app-bar absolute app class="pa-3" color="secondary" elevation="0">
    <v-btn v-if="$store.state.user" @click="$router.go(-1)" icon>
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <v-spacer></v-spacer>
    <v-img
      class="ma-4"
      contain
      max-height="50"
      max-width="200"
      @click="$router.push({ name: 'Panel' })"
      src="@/assets/home/logo-iap-2.gif"
    ></v-img>
    <v-spacer></v-spacer>
    <v-btn v-if="$store.state.user" @click="logOut" icon>
      <v-icon>mdi-logout</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
import firebase from "firebase";

export default {
  components: {},
  data() {
    return { tab: null };
  },
  methods: {
    logOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.push("/login");
          // Sign-out successful.
        })
        .catch(error => {
          console.log(error);
          // An error happened.
        });
    }
  }
};
</script>

<style>
/* Helper classes */
.basil {
  background-color: #fffbe6 !important;
}
.basil--text {
  color: #356859 !important;
}
</style>